<!-- <app-breadcrump-header [buttons]="buttons" [breadcrubs]="breadcrubs"></app-breadcrump-header> -->

<div #ticketDetail id="td-flex-container" [ngClass]="{'mobile': !resizeManager.isWeb || isPage}" [class.loadingEnd]="!general.singleTicketLoading">
  <section (scroll)="onScroll($event)" id="ticket-detail" [ngClass]="{'dark': isDarkmode, 'light': !isDarkmode}" [class.isPage]="isPage" [class.moreOpenContent]="isMoreOpen">

    @if (!platform.is('capacitor')) {
      <div id="socketUsers">
        @for (user of ticketSrv.socketUser; track user) {
          <app-socket-ticket-users [user]="user"></app-socket-ticket-users>
        }
      </div>
    }

    @if (!resizeManager.isWeb || isPage) {
      <div style="padding: 0 15px">
        <ion-segment scrollable  mode="ios" [value]="openMoreSegmentValue" (ionChange)="segmentValueChanged($event)">
          <ion-segment-button value="overview" layout="icon-start" >
            <ion-icon name="fa-comment" mode="ios"></ion-icon>
            <!-- <ion-label>Übersicht</ion-label> -->
          </ion-segment-button>
          <ion-segment-button value="settings" layout="icon-start" >
            <!-- <ion-label>Allgemein</ion-label> -->
            <ion-icon name="fa-gear" mode="ios"></ion-icon>
          </ion-segment-button>
          <ion-segment-button value="appointments" layout="icon-start" >
            <ion-icon name="fa-calendar" mode="md"></ion-icon>
          </ion-segment-button>
          <ion-segment-button value="files" layout="icon-start" >
            <!-- <ion-label>Anhänge</ion-label> -->
            <ion-icon name="fa-file" mode="md"></ion-icon>
          </ion-segment-button>
          <ion-segment-button value="times" layout="icon-start" >
            <!-- <ion-label>Zeiten</ion-label> -->
            <ion-icon name="fa-timer" mode="md"></ion-icon>
          </ion-segment-button>
        </ion-segment>
      </div>
    }

    @if(ticketSrv.ticket?.isCustomerRequest) {
      <support-assign-box [ticket]="ticketSrv.ticket"></support-assign-box>
    }
    
    @if(ticketSrv.appointmentRequest) {
      <appointment-assign-box [appointmentRequest]="ticketSrv.appointmentRequest" [disabled]="ticketSrv.ticket?.isCustomerRequest"></appointment-assign-box>
    }

    @if (openMoreSegmentValue == 'overview' || (resizeManager.isWeb && !isPage)) {
      <section id="overview">
        <div id="controls">
          <!-- TICKETSTATUS -->
          <div class="filter-bttn disabled" [class.disabled]="ticketSrv.ticket?.isCustomerRequest" id="state-selection" (click)="showTicketStates($event)">
            <div class="fiter-bttn-content">
              <div [ngStyle]="{background: ticketSrv?.ticket?.state | TicketStateColor : ticketSrv?.ticket?.isClosed}"></div>
              <div class="description">{{ticketSrv?.ticket?.state| TicketStateDescription}}</div>
            </div>
            @if (!isStateLoading) {
              <ion-icon name="fa-caret-down"></ion-icon>
            }
            @if (isStateLoading) {
              <ion-icon name="fa-spinner" class="spinner"></ion-icon>
            }
          </div>
          <!-- ARBEITSSCHRITT -->
          <div id="workstepsec">
            <div id="worksteps" class="filter-bttn" style="width: calc(100% - 35px)" (click)="openWorkSteps($event)">
              @if (ticketSrv.isLoading) {
                <div class="custom-skeleton" style="margin: 0;">
                  <ion-skeleton-text animated style="width: 200px; margin: 0;"></ion-skeleton-text>
                </div>
              }
              @if (!ticketSrv.isLoading) {
                <div>
                  Nr.{{ticketSrv.activeWorkstep?.number}} @if (ticketSrv.activeWorkstep?.description) {
                  <span>/ {{ticketSrv.activeWorkstep?.description}}</span>
                  } / {{ticketSrv.activeWorkstep?.contactDescription}} / {{ticketSrv.activeWorkstep?.employee?.firstName}} {{ticketSrv.activeWorkstep?.employee?.lastName}}
                </div>
              }
              <div>
                <ion-icon name="fa-caret-down"></ion-icon>
              </div>
            </div>
            <div class="hover-bttn" (click)="openWorkstepSelect($event)">
              <ion-icon name="fa-ellipsis-vertical"></ion-icon>
            </div>
          </div>
        </div>
        <!-- ALLGEMEINE INFORMATIONEN -->
        @if (!ticketSrv.isLoading) {
          <div id="main-daten">
            <h4>TicketNr.: {{ticketSrv.ticket.number}}</h4>
            <div class="ticket-name">
              <h1>{{ticketSrv.ticket.description}}</h1>
              <div class="hover-bttn" (click)="changeTicketName()">
                <ion-icon name="fa-pen"></ion-icon>
              </div>
            </div>
            @if (ticketSrv.activeWorkstep?.description) {
              <h2>Arbeitsschritt: {{ticketSrv.activeWorkstep?.description}}</h2>
            }
            <h2>{{ticketSrv.ticket.addressSearchText}}</h2>
            <app-tag-assign-input></app-tag-assign-input>
          </div>
        }
        <!-- <div *ngIf="ticketSrv.isLoading">
        <div class="custom-skeleton">
          <ion-skeleton-text animated style="width: 30%; max-width: 100px;"></ion-skeleton-text>
          <ion-skeleton-text animated style="width: 50%; max-width: 200px;"></ion-skeleton-text>
          <ion-skeleton-text animated style="width: 40%; max-width: 160px;"></ion-skeleton-text>
          <ion-skeleton-text animated style="width: 60%; max-width: 230px; margin-bottom: 50px;"></ion-skeleton-text>
        </div>
      </div> -->
      @if (general.webConfig?.show_ticket_tasks) {
        <ion-segment mode="ios" id="contentSegment" [value]="contentSegementValue" (ionChange)="setContentSegmentValue($event)">
          <ion-segment-button layout="icon-start" value="messages">
            <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="message" class="svg-inline--fa fa-message" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M511.1 63.1v287.1c0 35.25-28.75 63.1-64 63.1h-144l-124.9 93.68c-7.875 5.75-19.12 .0497-19.12-9.7v-83.98h-96c-35.25 0-64-28.75-64-63.1V63.1c0-35.25 28.75-63.1 64-63.1h384C483.2 0 511.1 28.75 511.1 63.1z"></path></svg>
            <ion-label>Nachrichten</ion-label>
          </ion-segment-button>
          <ion-segment-button layout="icon-start" value="tasks">
            <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="circle-check" class="svg-inline--fa fa-circle-check" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM371.8 211.8l-128 128C238.3 345.3 231.2 348 224 348s-14.34-2.719-19.81-8.188l-64-64c-10.91-10.94-10.91-28.69 0-39.63c10.94-10.94 28.69-10.94 39.63 0L224 280.4l108.2-108.2c10.94-10.94 28.69-10.94 39.63 0C382.7 183.1 382.7 200.9 371.8 211.8z"></path></svg>
            <ion-label>Tätigkeiten <span>( {{getCompleteTasksCount()}} / {{ticketSrv.tasks.length}} )</span></ion-label>
          </ion-segment-button>
        </ion-segment>
      }
      <!--NACHRICHTEN-->
      @if (contentSegementValue == 'messages') {
        <section>
          <div #searchAdd id="search-add" [class.searchAddMobile]="searchAdd.getBoundingClientRect().width <= 400">
            <div class="search" style="width: 100%; margin: 0;">
              <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="search" class="search-icon svg-inline--fa fa-search fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="#B2B2B2" d="M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z"></path></svg>
              <input #search type="search" class="search-input" placeholder="Inhalt, Mitarbeiter..." [(ngModel)]="searchValue" (keyup)="searchWorkstepContent()"/>
            </div>
            <div id="sa-buttons">
              <div class="c-bttn" (click)="addWorkstepContent()" title="Strg + M" style="min-width: 100px;">
                <ion-icon name="fa-plus" style="margin-right: 5px;"></ion-icon>
                Eintrag
              </div>
              @if (general.serverVersionGreaterThan('1.8.0') && general.webConfig.hasDesktopPfad) {
                <div class="c-bttn" (click)="addWorkstepContent(true)" title="Strg + M" style="min-width: 100px;">
                  <ion-icon name="fa-mail-unread" style="margin-right: 8px;"></ion-icon>
                  E-Mail
                </div>
              }
            </div>
          </div>
          @if (ticketSrv.hasWorkstepContentEditValue) {
            <app-content-edit-popup (closed)="workstepContentClosed($event)"></app-content-edit-popup>
          }
          <div id="message-history">
            <div style="padding-bottom: 30px;">
              @for (item of ticketSrv.workstepContentWithAttachment; track item; let i = $index) {
                <div>
                  @if (item.type == 'content') {
                    <div>
                      <app-workstep-content [withLine]="ticketSrv.workstepContentWithAttachment.length != i+1" [isLoading]="false" [content]="item?.content" [hightlight]="item?.content?.id == highlightedContentId" [contentOnEditID]="contentOnEditID" (onEdit)="onWorkstepContentEdit($event)" (mailByContent)="addWorkstepContent(true, $event)"></app-workstep-content>
                    </div>
                  }
                  @if (item.type == 'attachment') {
                    <div >
                      <asset-item [attachment]="item.attachment" [maxWidth350]="true" [withBorder]="true"></asset-item>
                      @if (ticketSrv.workstepContentWithAttachment.length != i+1) {
                        <div class="connect-line"></div>
                      }
                    </div>
                  }
                </div>
              }
            </div>
            <!-- <div>
            <svg id="content-spinner" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="spinner-third" class="svg-inline--fa fa-spinner-third fa-w-16 spinner" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M283.2 65.92C267.6 63.69 256 50.32 256 34.52c0-19.38 17.19-34.69 36.38-31.95C416.4 20.29 512 127.2 512 256c0 33.38-6.544 65.26-18.27 94.49c-7.162 17.86-28.85 24.87-45.56 15.32c-13.74-7.854-19.62-24.53-13.75-39.23C443.2 304.7 448 280.9 448 256C448 159.4 376.3 79.18 283.2 65.92z"></path></svg>
          </div> -->
          @if (ticketSrv.workstepContent.length == 0) {
            <p class="no-content">Kein Inhalt gefunden</p>
          }
        </div>
        @if (!isPage) {
          <section id="loading" [ngStyle]="{'opacity': ticketSrv.workstepCanMoreLoad && ticketSrv.workstepContent.length > 24 ? '1' : '0'}">
            <svg class="spinner" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path fill="var(--text)" d="M256 32C256 14.33 270.3 0 288 0C429.4 0 544 114.6 544 256C544 302.6 531.5 346.4 509.7 384C500.9 399.3 481.3 404.6 465.1 395.7C450.7 386.9 445.5 367.3 454.3 351.1C470.6 323.8 480 291 480 255.1C480 149.1 394 63.1 288 63.1C270.3 63.1 256 49.67 256 31.1V32z"/></svg>
          </section>
        }
        @if (isPage && !general.singleTicketLoading) {
          <ion-infinite-scroll (ionInfinite)="onScroll($event)" style="--color: rgba(var(--textRGB), 0.4);">
            <ion-infinite-scroll-content></ion-infinite-scroll-content>
          </ion-infinite-scroll>
        }
      </section>
    }
    <!--TÄTIGKEITEN-->
    @if (contentSegementValue == 'tasks') {
      <section  >
        <div id="taskHeader">
          <div class="search">
            <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="circle-plus" class="svg-inline--fa fa-circle-plus search-icon" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="#B2B2B2" d="M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256C397.4 512 512 397.4 512 256S397.4 0 256 0zM352 280H280V352c0 13.2-10.8 24-23.1 24C242.8 376 232 365.2 232 352V280H160C146.8 280 136 269.2 136 256c0-13.2 10.8-24 24-24H232V160c0-13.2 10.8-24 24-24C269.2 136 280 146.8 280 160v72h72C365.2 232 376 242.8 376 256C376 269.2 365.2 280 352 280z"></path></svg>
            <input #taskAddInput type="text" class="search-input" placeholder="Neue Tätigkeit..." [(ngModel)]="taskAddText" (keydown)="addNewTask($event)"/>
          </div>
          <div class="c-bttn" (click)="addNewTask()">
            <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="plus" class="svg-inline--fa fa-plus" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M432 256c0 17.69-14.33 32.01-32 32.01H256v144c0 17.69-14.33 31.99-32 31.99s-32-14.3-32-31.99v-144H48c-17.67 0-32-14.32-32-32.01s14.33-31.99 32-31.99H192v-144c0-17.69 14.33-32.01 32-32.01s32 14.32 32 32.01v144h144C417.7 224 432 238.3 432 256z"></path></svg>
          </div>
          <div class="hover-bttn" (click)="openTaskPopover($event)">
            <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="ellipsis-vertical" class="svg-inline--fa fa-ellipsis-vertical" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128 512"><path fill="currentColor" d="M128 64c0-35.39-28.62-64-64-64S0 28.61 0 64s28.62 64 64 64S128 99.39 128 64zM128 256c0-35.39-28.62-64-64-64S0 220.6 0 256s28.62 64 64 64S128 291.4 128 256zM128 448c0-35.39-28.62-64-64-64s-64 28.61-64 64s28.62 64 64 64S128 483.4 128 448z"></path></svg>
          </div>
        </div>
        <section>
          <ion-reorder-group [disabled]="false"  (ionItemReorder)="handleTaskReorder($any($event))">
            @for (task of ticketSrv.tasks; track task) {
              <ion-item class="taskItem"  [class.checked]="task.checked" (click)="checkTask(task)">
                @if (general.serverVersionGreaterThan('1.7.0')) {
                  <ion-reorder slot="start">
                    <ion-icon name="fa-grip-lines"></ion-icon>
                  </ion-reorder>
                }
                @if (task.checked) {
                  <svg slot="start" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="circle-check" class="svg-inline--fa fa-circle-check" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM371.8 211.8l-128 128C238.3 345.3 231.2 348 224 348s-14.34-2.719-19.81-8.188l-64-64c-10.91-10.94-10.91-28.69 0-39.63c10.94-10.94 28.69-10.94 39.63 0L224 280.4l108.2-108.2c10.94-10.94 28.69-10.94 39.63 0C382.7 183.1 382.7 200.9 371.8 211.8z"></path></svg>
                }
                @if (!task.checked) {
                  <div slot="start"  class="none-checked"></div>
                }
                <ion-label>
                  <h2 position="floating">{{task.description}}</h2>
                  <h3>Einträge: {{task?.contentCount}}</h3>
                </ion-label>
                <div slot="end" style="display: flex; align-items: center;">
                  @if (isTaskTimeActive(task.id)) {
                    <div class="more taskTimeIcon" (click)="openTimeByTask($event, task.id)">
                      <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="timer" class="svg-inline--fa fa-timer" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256C0 184.4 29.46 119.6 76.84 73.14C89.46 60.78 109.7 60.98 122.1 73.6C134.5 86.23 134.3 106.5 121.6 118.9C86.03 153.7 64 202.3 64 256C64 362 149.1 448 256 448C362 448 448 362 448 256C448 160.9 378.8 81.89 288 66.65V96C288 113.7 273.7 128 256 128C238.3 128 224 113.7 224 96V32C224 14.33 238.3 0 256 0C397.4 0 512 114.6 512 256zM272.1 239C282.3 248.4 282.3 263.6 272.1 272.1C263.6 282.3 248.4 282.3 239 272.1L159 192.1C149.7 183.6 149.7 168.4 159 159C168.4 149.7 183.6 149.7 192.1 159L272.1 239z"></path></svg>
                    </div>
                  }
                  <div class="more" (click)="openTaskOptions($event, task)">
                    <svg  aria-hidden="true" focusable="false" data-prefix="fas" data-icon="ellipsis-vertical" class="svg-inline--fa fa-ellipsis-vertical" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128 512"><path fill="currentColor" d="M64 360C94.93 360 120 385.1 120 416C120 446.9 94.93 472 64 472C33.07 472 8 446.9 8 416C8 385.1 33.07 360 64 360zM64 200C94.93 200 120 225.1 120 256C120 286.9 94.93 312 64 312C33.07 312 8 286.9 8 256C8 225.1 33.07 200 64 200zM64 152C33.07 152 8 126.9 8 96C8 65.07 33.07 40 64 40C94.93 40 120 65.07 120 96C120 126.9 94.93 152 64 152z"></path></svg>
                  </div>
                </div>
              </ion-item>
            }
          </ion-reorder-group>
        </section>
        @if (ticketSrv.tasks.length == 0) {
          <p class="no-content">Keine Tätigkeiten gefunden</p>
        }
      </section>
    }
  </section>
}

<!--Nur für Mobil-->
<div style="padding: 0 15px;">
  @if ((!resizeManager.isWeb || isPage) && openMoreSegmentValue == 'settings') {
    <app-ticket-detail-allgemein></app-ticket-detail-allgemein>
  }
  @if ((!resizeManager.isWeb || isPage) && openMoreSegmentValue == 'appointments') {
    <ticket-detail-appointments></ticket-detail-appointments>
  }
  @if ((!resizeManager.isWeb || isPage) && openMoreSegmentValue == 'files') {
    <app-ticket-detail-assets></app-ticket-detail-assets>
  }
  @if ((!resizeManager.isWeb || isPage) && openMoreSegmentValue == 'times') {
    <app-ticket-detail-zeiten ></app-ticket-detail-zeiten>
  }
</div>

</section>


<!--Nur für Desktop-->
@if (resizeManager.isWeb && !isPage) {
  <section id="td-tmbar"  [ngClass]="{'dark': isDarkmode, 'light': !isDarkmode}" [class.tdtmbarClosed]="isMoreOpen" [class.tdtmbarOpen]="!isMoreOpen">
    <div class="td-tmbar-item">
      <svg (click)="openMore('settings')" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="tools" class="svg-inline--fa fa-tools fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="#fff" d="M501.1 395.7L384 278.6c-23.1-23.1-57.6-27.6-85.4-13.9L192 158.1V96L64 0 0 64l96 128h62.1l106.6 106.6c-13.6 27.8-9.2 62.3 13.9 85.4l117.1 117.1c14.6 14.6 38.2 14.6 52.7 0l52.7-52.7c14.5-14.6 14.5-38.2 0-52.7zM331.7 225c28.3 0 54.9 11 74.9 31l19.4 19.4c15.8-6.9 30.8-16.5 43.8-29.5 37.1-37.1 49.7-89.3 37.9-136.7-2.2-9-13.5-12.1-20.1-5.5l-74.4 74.4-67.9-11.3L334 98.9l74.4-74.4c6.6-6.6 3.4-17.9-5.7-20.2-47.4-11.7-99.6.9-136.6 37.9-28.5 28.5-41.9 66.1-41.2 103.6l82.1 82.1c8.1-1.9 16.5-2.9 24.7-2.9zm-103.9 82l-56.7-56.7L18.7 402.8c-25 25-25 65.5 0 90.5s65.5 25 90.5 0l123.6-123.6c-7.6-19.9-9.9-41.6-5-62.7zM64 472c-13.2 0-24-10.8-24-24 0-13.3 10.7-24 24-24s24 10.7 24 24c0 13.2-10.7 24-24 24z"></path></svg>
      <div>Allgemein</div>
    </div>
    <div class="td-tmbar-item">
      <svg (click)="openMore('appointments')"  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="#fff" d="M128 0c17.7 0 32 14.3 32 32l0 32 128 0 0-32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 32 48 0c26.5 0 48 21.5 48 48l0 48L0 160l0-48C0 85.5 21.5 64 48 64l48 0 0-32c0-17.7 14.3-32 32-32zM0 192l448 0 0 272c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48L0 192zm64 80l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm128 0l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zM64 400l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zm112 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16z"/></svg>
      <div>Termine</div>
    </div>
    <div class="td-tmbar-item">
      <svg (click)="openMore('files')"  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path fill="#fff" d="M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 288c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zm384 64l-128 0L256 0 384 128z"/></svg>
      <div>Anhänge</div>
    </div>
    <div class="td-tmbar-item">
      <svg (click)="openMore('times')" aria-hidden="true" focusable="false" data-prefix="far" data-icon="stopwatch" class="svg-inline--fa fa-stopwatch fa-w-14" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="#fff" d="M393.9 184l22.6-22.6c4.7-4.7 4.7-12.3 0-17l-17-17c-4.7-4.7-12.3-4.7-17 0l-20.7 20.7c-31.1-27.5-70.4-45.9-113.8-50.8V48h28c6.6 0 12-5.4 12-12V12c0-6.6-5.4-12-12-12H172c-6.6 0-12 5.4-12 12v24c0 6.6 5.4 12 12 12h28v49.4C96.4 109.3 16 197.2 16 304c0 114.9 93.1 208 208 208s208-93.1 208-208c0-44.7-14.1-86.1-38.1-120zM224 464c-88.4 0-160-71.6-160-160s71.6-160 160-160 160 71.6 160 160-71.6 160-160 160zm12-112h-24c-6.6 0-12-5.4-12-12V204c0-6.6 5.4-12 12-12h24c6.6 0 12 5.4 12 12v136c0 6.6-5.4 12-12 12z"></path></svg>
      <div>Ticketzeiten</div>
    </div>
  </section>
}

<!--Image Dragn Drop-->
<drop-zone [onParentDrop]="onParentDrop"></drop-zone>

@if (resizeManager.isWeb && !isPage) {
  <app-ticket-more [ngClass]="{'ticketMoreOpen': isMoreOpen, 'ticketMoreClose': !isMoreOpen}" [isDesktop]="true" (close)="isMoreOpen = $event" [isOpen]="isMoreOpen" [segmentValue]="openMoreSegmentValue"></app-ticket-more>
}
@if (isPage && ticketSrv.ticket?.address?.deliveryStop) {
  <deliver-stop-overlay (deliveryStopClosed)="ticketSrv.ticket.address.deliveryStop = $event"></deliver-stop-overlay>
}
</div>


